var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 col-lg-4",staticStyle:{"margin-bottom":"30px"}},[_c('div',{staticClass:"blog-block blog-item-cursor"},[_c('content-loader',{attrs:{"width":"600","height":"500","preserveAspectRatio":"none"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }